import { Plus } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useCreditsAccountInfo, useVisible } from 'src/hooks';
import { CreateApiKeyModal } from '../CreateAPIKeyModal';

export const CreateAPIKey = () => {
  const { isVisible, onVisibilitySet, onVisibilityRemove } = useVisible();
  const { creditAccountInfo } = useCreditsAccountInfo();

  const handleCreateNewKeyClick = () => {
    onVisibilitySet();
  };

  return (
    <>
      <Button
        onClick={handleCreateNewKeyClick}
        disabled={!creditAccountInfo?.reload_config?.auto_reload_enabled}
        tooltipContent={
          !creditAccountInfo?.reload_config?.auto_reload_enabled
            ? 'Enable auto-pay to create an API key'
            : undefined
        }
      >
        <Plus size={SVG_SIZE_M} />
        <span>Create a new key</span>
      </Button>

      <CreateApiKeyModal isOpen={isVisible} onClose={onVisibilityRemove} />
    </>
  );
};
